/**
 * DeleteDialog (wandering profile) — irreversible delete confirmation.
 *
 * Mirrors DeleteUserDialog's structure so the visual language stays
 * consistent across V2 profile pages.
 */

const DeleteDialog = ({ deviceName, onClose, onConfirm, saving }) => {
  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div
          className="pp-dialog__header"
          style={{ padding: 'var(--space-4) var(--space-5)', borderBottom: '1px solid var(--color-border)' }}
        >
          <h3 style={{ margin: 0, fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-danger)' }}>
            Delete Wandering Device
          </h3>
        </div>
        <div className="pp-dialog__body" style={{ padding: 'var(--space-5)' }}>
          <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
            Are you sure you want to permanently delete <strong>{deviceName || 'this device'}</strong>?
            This will remove the device from the system entirely and cannot be undone.
          </p>
        </div>
        <div
          className="pp-dialog__footer"
          style={{ padding: 'var(--space-4) var(--space-5)', display: 'flex', justifyContent: 'flex-end', gap: 'var(--space-3)', borderTop: '1px solid var(--color-border)' }}
        >
          <button type="button" className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button type="button" className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
            {saving ? 'Deleting…' : 'Delete Device'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDialog;
